import type { SVGProps } from "react";
import * as React from "react";
const SvgUkg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#2CD5C4"
      d="M6.937 4.467A2.469 2.469 0 1 1 2 4.47a2.469 2.469 0 0 1 4.937-.003ZM22 4.467A2.46 2.46 0 1 1 19.55 2 2.47 2.47 0 0 1 22 4.467Z"
    />
    <path
      fill="#005857"
      d="M12.02 22c-2.657-.002-5.205-.976-7.084-2.709-1.878-1.733-2.934-4.083-2.934-6.533v-1.466a2.02 2.02 0 0 1 .152-.857c.113-.273.285-.522.504-.733.22-.21.484-.378.776-.492a2.529 2.529 0 0 1 1.845 0c.291.114.555.282.775.492.22.21.391.46.504.733.113.274.165.565.152.857v1.523c0 2.685 1.727 4.874 5.29 4.874 3.314 0 5.288-2.19 5.288-4.874v-1.523c-.018-.295.03-.59.14-.867.111-.278.282-.531.502-.746a2.37 2.37 0 0 1 .78-.502 2.53 2.53 0 0 1 1.864 0c.294.117.56.288.78.502.22.215.391.468.502.745.11.278.158.573.14.868v1.466a8.57 8.57 0 0 1-.746 3.534 9.175 9.175 0 0 1-2.162 3c-.928.858-2.03 1.538-3.245 2.002a10.71 10.71 0 0 1-3.83.701"
    />
  </svg>
);
export default SvgUkg;
